export default __webpack_public_path__ + "static/media/white_bg_2_1.1a8163b7.webp";